import React from 'react';
import { CredusText, CredusWrapper } from 'ui';
import { NoData } from '../assets/images/svgs';

type Props = {
  description?: string;
  margin?: string;
};

const EmptyState = ({ description, margin }: Props) => {
  return (
    <CredusWrapper
      margin={margin}
      display="flex"
      direction="column"
      align="center"
    >
      <NoData />
      <CredusText mt="2.375rem" size="lg" weight="regular">
        {description}
      </CredusText>
    </CredusWrapper>
  );
};

export default EmptyState;
